
import axios from 'axios';
import axios2 from '../api/axios';
import {localapiurl} from '../constant';


export const userservices = {
    getusers,
    deleteuser,
    updateuser,
    adduser,
    getusersfiltered  
}

async function getusers(){
     return axios2.get('/getusers').then((response)=>{
            return response;  
        }).catch((error)=>{
            console.log("error "); 
            console.log(error);
      });
}

function getusersfiltered({status}){
    return axios2.get(`/getusersfiltered?status=${status}`).then((response)=>{
        return response;  
    }).catch((error)=>{
        console.log("error "); 
        console.log(error);
  });
}


async function deleteuser(objdata){
    let data = objdata;   
    return axios({
        method: 'post',
        url: `${localapiurl}/register`,
        data: data,
      }).then((response)=>{
          console.log("response data");
          console.log(response);
          if(response.status == 200){
            //   console.log(response.data.token); 
              let tokendata = response.data.token;
              localStorage.setItem('token',tokendata);  
              window.location.href = '/';  
          }else{

          }
      }).catch((error)=>{
         console.log("error");
         console.log(error);
      });     
}


function updateuser(objdata){
    let data = objdata;
    return axios({
        method: 'post',
        url: `${localapiurl}/logout`,
        data: data
      }).then((response)=>{
           return response;
      }).catch((error)=>{
           console.log(error);
      });     
}


function adduser(objdata){
    let data = objdata;
    return axios2.post('/adduser',data).then((response)=>{
        return response;  
    }).catch((error)=>{
        console.log("error "); 
        console.log(error);
   });
}